<div
    class="bg-white rounded border border-sienna relative mt-2 px-2 py-1"
>
    <div class="flex gap-2">
        <fa-icon [icon]="faEnvelopeCircleCheck" class="text-sienna" />
        <div class="font-bold text-sienna">Letterbox service</div>
    </div>
    <div class="text-sm text-gray-600">
        This product qualifies for our reduced-price letterbox service to the UK! See
        the "Delivery & Returns" tab below for more information.
    </div>
</div>
